import classNames from "classnames";
import { FC, memo } from "react";
import { Portal } from "react-portal";
import { CSSTransition } from "react-transition-group";
import { rootElement } from "~@/index";

export enum OverlayTransparency {
  Zero,
  Ten,
  Thirty,
}

type OverlayProps = {
  showOverlay: boolean;
  overlayTransparency: OverlayTransparency;
};

const Overlay: FC<OverlayProps> = ({ showOverlay, overlayTransparency }) => {
  return (
    <CSSTransition
      in={showOverlay}
      mountOnEnter
      unmountOnExit
      timeout={200}
      classNames="fade"
    >
      <Portal node={rootElement}>
        <div
          className={classNames("overlay", {
            "overlay--has-transparency-0":
              overlayTransparency === OverlayTransparency.Zero,
            "overlay--has-transparency-10":
              overlayTransparency === OverlayTransparency.Ten,
            "overlay--has-transparency-30":
              overlayTransparency === OverlayTransparency.Thirty,
          })}
        />
      </Portal>
    </CSSTransition>
  );
};

export default memo(Overlay);
